export function redirectData() {
  return {
    redirectPageMapPcToM: {
      '/': 'support',
      'manual/questionClassifiy': 'selfInspectManual/questionClass',
      'manual/questionDetail': 'selfInspectManual/questionDetail',
      'product/modelSelect': 'vehicleSupport/modelSelect',
      'product/seriesSelect': 'vehicleSupport/seriesSelect',
      selfRepair: 'selfRepair/tips',
      'selfRepair/videoDetail': 'selfRepair/videoDetail',
      'selfRepair/videoList': 'selfRepair',
      vehicle: 'vehicleSupport/home',
      'vehicle/video': 'vehicleSupport/teachVideo',
      'vehicle/videoDetail': 'vehicleSupport/videoDetail',
      'instructions/list': 'instructions/list',
      'policy/list': 'policy/list',
      'policy/detail': 'policy/detail',
      onlineRepair: 'onlineRepair',
      'onlineRepair/success': 'onlineRepair/success',
      dealerService: 'dealerService',
      pdf: 'pdf',
      search: 'search',
      'search/download': 'search/download',
      'search/questionDetail': 'search/questionDetail',
      'search/selfRepairDetail': 'search/selfRepairDetail',
      'search/vehicleVideo': 'search/vehicleVideo',
      serviceCenter: 'serviceCenter',
      '404': '404',
      mailRepair: 'mailRepair',
      'mailRepair/list': 'mailRepair/list',
      'mailRepair/detail': 'mailRepair/detail',
      'mailRepair/notReceived': 'mailRepair/notReceived',
      recall: 'recall',
      onlineChat: 'onlineChat',
      international: 'international',
      regulations: 'regulations',
      serviceNetwork: 'serviceNetwork',
      g30RecallNotice: 'g30RecallNotice',
      accessoriesPrice: 'accessoryPrices',
      accessoryPrices: 'accessoryPrices',
      'accessoryPrices/search': 'accessoryPrices/search',
      coc: 'coc'
    },
    redirectPageMapMToPc: {
      '/': '',
      support: '',
      'selfInspectManual/questionClass': 'manual/questionClassifiy',
      'selfInspectManual/questionDetail': 'manual/questionDetail',
      selfRepair: 'selfRepair/videoList',
      'selfRepair/tips': 'selfRepair',
      'selfRepair/videoDetail': 'selfRepair/videoDetail',
      'vehicleSupport/home': 'vehicle',
      'vehicleSupport/modelSelect': 'product/modelSelect',
      'vehicleSupport/seriesSelect': 'product/seriesSelect',
      'vehicleSupport/teachVideo': 'vehicle/video',
      'vehicleSupport/videoDetail': 'vehicle/videoDetail',
      'instructions/list': 'instructions/list',
      'policy/list': 'policy/list',
      'policy/detail': 'policy/detail',
      onlineRepair: 'onlineRepair',
      'onlineRepair/success': 'onlineRepair/success',
      dealerService: 'dealerService',
      pdf: 'pdf',
      search: 'search',
      'search/download': 'search/download',
      'search/questionDetail': 'search/questionDetail',
      'search/selfRepairDetail': 'search/selfRepairDetail',
      'search/vehicleVideo': 'search/vehicleVideo',
      serviceCenter: 'serviceCenter',
      '404': '404',
      mailRepair: 'mailRepair',
      'mailRepair/list': 'mailRepair/list',
      'mailRepair/detail': 'mailRepair/detail',
      'mailRepair/notReceived': 'mailRepair/notReceived',
      recall: 'recall',
      onlineChat: 'onlineChat',
      international: 'international',
      regulations: 'regulations',
      serviceNetwork: 'serviceNetwork',
      g30RecallNotice: 'g30RecallNotice',
      accessoriesPrice: 'accessoryPrices',
      accessoryPrices: 'accessoryPrices',
      'accessoryPrices/search': 'accessoryPrices/search',
      coc: 'coc'
    },
    baseURLMap: {
      'https://test-service.ninebot.com/':
        'https://test-mobile-service.ninebot.com/', // 测试pc -> mobile
      'https://test-mobile-service.ninebot.com/':
        'https://test-service.ninebot.com/', // 测试mobile -> pc
      'https://service-m.segway.com/': 'https://service.segway.com/', // 海外正式 mobile -> pc
      'https://service.segway.com/': 'https://service-m.segway.com/', // 海外正式 pc -> mobile
      'https://support-m.ninebot.com/': 'https://support.ninebot.com/', // 国内正式 mobile -> pc
      'https://support.ninebot.com/': 'https://support-m.ninebot.com/', // 国内正式 pc -> mobile
      'https://gray-service.ninebot.com/':
        'https://gray-mobile-service.ninebot.com/', // 灰度pc -> mobile
      'https://gray-mobile-service.ninebot.com/':
        'https://gray-service.ninebot.com/', // 灰度 mobile -> pc
      'https://gray-service-os.ninebot.com/':
        'https://gray-mobile-service-os.ninebot.com/', // PC ->M
      'https://gray-mobile-service-os.ninebot.com/':
        'https://gray-service-os.ninebot.com/', // M ->pc
      'https://test-service-os.ninebot.com/':
        'https://test-mobile-service-os.ninebot.com/', // 海外测试pc -> mobile
      'https://test-mobile-service-os.ninebot.com/':
        'https://test-service-os.ninebot.com/' // 海外测试mobile -> pc
    }
  };
}
